"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var MessageAction;
(function (MessageAction) {
    MessageAction.ON_SET_GLOBAL_MESSAGE_POP = 'ON_SET_GLOBAL_MESSAGE_POP';
    MessageAction.ON_SET_GLOBAL_MESSAGE_ACTIVE = 'ON_SET_GLOBAL_MESSAGE_ACTIVE';
    MessageAction.ON_MESSAGE_CLOSE = 'ON_MESSAGE_CLOSE';
    MessageAction.onSetMessage = typesafe_actions_1.createAction(MessageAction.ON_SET_GLOBAL_MESSAGE_POP, function (resolve) { return function (message, warningLevel, title, actionUrl, actionText) {
        if (warningLevel === void 0) { warningLevel = 0; }
        if (title === void 0) { title = ""; }
        if (actionUrl === void 0) { actionUrl = ""; }
        if (actionText === void 0) { actionText = ""; }
        return resolve({ title: title, message: message, actionUrl: actionUrl, actionText: actionText, warningLevel: warningLevel });
    }; });
    MessageAction.onSetActive = typesafe_actions_1.createAction(MessageAction.ON_SET_GLOBAL_MESSAGE_ACTIVE, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    MessageAction.messageClose = typesafe_actions_1.createAction(MessageAction.ON_MESSAGE_CLOSE, function (resolve) { return function () {
        return resolve();
    }; });
})(MessageAction || (MessageAction = {}));
exports.default = MessageAction;
